import styled from 'styled-components';
import { Tag } from 'antd';

interface StyledTagItemProps {
  $isDefault?: boolean;
}

const StyledTagInputWrapper = styled.div`
  position: relative;
  display: flex;
  row-gap: 0.4rem;
  flex-wrap: wrap;
  background-color: ${(props) => props.theme.colors.secondaryBg};
  border: 1px solid ${(props) => props.theme.colors.primaryBorder};
  border-radius: ${(props) => props.theme.customBorderRadius.borderRadiusSmall};
  padding: 0.2rem 2.4rem 0.2rem 0.57rem;
`;

const StyledTagItem = styled(Tag)<StyledTagItemProps>`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  line-height: 1.71rem;
  margin-inline-end: 0.72rem;
  border: none;
  background-color: ${(props) => (props.$isDefault ? props.theme.colors.blue : props.theme.colors.grayButton)};
  color: ${(props) => (props.$isDefault ? props.theme.colors.white : props.theme.colors.primaryText)};
  font-size: ${(props) => props.theme.typography.fontSizeSmall};
  cursor: ${(props) => (props.$isDefault ? 'auto' : 'pointer')};

  .ant-tag-close-icon {
    margin-inline-start: 0;
    path {
      fill: ${(props) => (props.$isDefault ? props.theme.colors.white : props.theme.colors.primaryText)};
    }
  }
`;

const StyledAddTagInput = styled.div`
  font-size: ${(props) => props.theme.typography.fontSizeSmall};
  & input.ant-input {
    padding: 0.25rem 10px 0.25rem 0;
    border-radius: 0;
    width: 6.42rem;
    border: none !important;

    &:focus {
      box-shadow: none;
    }
  }
`;

const StyledTagsClear = styled.div`
  position: absolute;
  right: 0.2rem;
  top: 50%;
  transform: translateY(-50%);
  padding: 0.28rem;
  cursor: pointer;

  &:hover svg path {
    fill: ${(props) => props.theme.colors.hover};
  }
`;

export {
  StyledTagInputWrapper, StyledTagItem, StyledAddTagInput, StyledTagsClear,
};
